<section *ngIf="!isOpened">
  <div class="row">
    <form class="needs-validation container-style" novalidate [formGroup]="formBranch">
      <div class="ps-2 pe-2">
        <div class="row pt-1">
          <div class="col">
            <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
              [width]="'6rem'" [routerLink]="['/', url]" [severity]="null"></app-custom-button>
          </div>
          <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
            <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
          </div>

          <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
            <app-custom-button [title]="'Eliminar'" [icon]="'pi pi-trash'" [severity]="'contrast'"
              (onClick)="deleteBranch()"></app-custom-button>

            <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'" [width]="'5.5rem'"
              [severity]="'success'" [variant]="undefined" (onClick)="createNewRegister()"></app-custom-button>
          </div>
          <hr class="my-1">
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <app-custom-audit-info [userNameCreate]="branchContract.userNameCreate"
              [createDate]="branchContract.createDate" [userNameUpdate]="branchContract.userNameUpdate"
              [updateDate]="branchContract.updateDate" [reserveSpace]="true"></app-custom-audit-info>
          </div>
        </div>
      </div>
      <div class="row d-flex justify-content-between">
        <div class="col-lg-6 col-sm-12 col-12">
          <div class="row">
            <div class="col field-code">
              <app-custom-input-number formControlName="code" [labelText]="'Código'" [required]="true" [recovery]="true"
                (onChangeNumber)="changeCode($event)"></app-custom-input-number>
            </div>
            <div class="col field-alterCode">
              <app-custom-input-text formControlName="alterCode" [labelText]="'Cód. Alterno'" [maxLength]="10">
              </app-custom-input-text>
            </div>
            <div class="col field-alterCode2">
              <app-custom-input-text formControlName="alterCode2" [labelText]="'Cód. Alterno2'" [maxLength]="10">
              </app-custom-input-text>
            </div>
            <div class="col field-name">
              <app-custom-input-text formControlName="name" [labelText]="'Nombre'" [maxLength]="100"
                [required]="true"></app-custom-input-text>
            </div>
            <div class="col field-address">
              <app-custom-input-text formControlName="address" [labelText]="'Dirección'" [maxLength]="70"
                [required]="true"></app-custom-input-text>
            </div>
            <div class="col field-email">
              <app-custom-input-text formControlName="email" [labelText]="'Correo'" [maxLength]="50"
                [required]="true"></app-custom-input-text>
            </div>
            <div class="col field-phone">
              <app-custom-input-text formControlName="phone" [labelText]="'Teléfono'" [maxLength]="15"
                [required]="true"></app-custom-input-text>
            </div>
          </div>
        </div>
        <div class="col-lg-5 col-sm-12 col-12">
          <div class="row">
            <div class="col field-city">
              <app-custom-inputgroup [inputValue]="city" [labelText]="'Ciudad'" [iconButton]="'pi pi-external-link'"
                [titleButton]="'Seleccionar Ciudad'" [required]="true"
                (onClick)="openCitySelectionModal()"></app-custom-inputgroup>
              <app-custom-modal #selectCity [label]="'Seleccionar'" [header]="'Selección de Ciudades'" [width]="'75vw'"
                [children]="componentCitySelection" [inputs$]="inputsForSelectCityModal$" [output$]="output$"
                (selectedItems)="setCityDepartment($event)" hidden></app-custom-modal>
            </div>
            <div class="col field-department">
              <app-custom-input-text [value]="department" [labelText]="'Departamento'" [disabled]="true"
                [required]="true"></app-custom-input-text>
            </div>
            <div class="col field-logisticsEmail">
              <app-custom-input-text formControlName="logisticsEmail" [labelText]="'Correo Lógistica'" [maxLength]="50"
                [required]="true"></app-custom-input-text>
            </div>
            <div class="col field-reteIvaCode">
              <app-custom-input-text formControlName="reteIvaCode" [labelText]="'Cód. ReteIva'" [maxLength]="10">
              </app-custom-input-text>
            </div>
            <div class="col field-buttons">
              <app-custom-button [title]="'Opciones Avanzadas'" [label]="'Opciones Avanzadas'" [severity]="'contrast'"
                [width]="'9rem'" (onClick)="openAdvancedOptions()">
              </app-custom-button>
              <app-custom-modal #advancedOptions [label]="'Opciones Avanzadas'" [header]="'Opciones Avanzadas'"
                [inputs$]="inputsForAdvancedOptionsModals$" [children]="componentAdvancedOptions" [width]="'60vw'"
                hidden>
              </app-custom-modal>
              <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [severity]="'primary'" [variant]="undefined"
                [disabled]="disabledForm" (onClick)="send()">
              </app-custom-button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>
<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>